import { render, staticRenderFns } from "./ProReview.vue?vue&type=template&id=77743f40&"
import script from "./ProReview.vue?vue&type=script&lang=js&"
export * from "./ProReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports